import { END_POINT } from "@constants/api.constants";
import { PRIMARY_KEY } from "@constants/app.constants";

const keyColumn = PRIMARY_KEY;
const { SMS_TEMPLATE_STATUS_TOGGLE } = END_POINT;
const tableTitle = "SMS Template";
const menuUrl = "system/sms-template";
const tableColumn = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "content",
    numeric: false,
    disablePadding: true,
    label: "SMS Content",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    badgeClick: SMS_TEMPLATE_STATUS_TOGGLE,
    primaryKey: keyColumn,
    badgeText: {
      1: "Enabled",
      2: "Disabled",
    },
    badgeColor: {
      1: "success",
      2: "danger",
    },
  },
];
const breadCrumbs = [
  { name: "System", menu_url: null },
  { name: "SMS Template", menu_url: "/system/sms-template" },
];

const filters = [
  {
    name: "name",
    id: "name",
    label: "Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export { tableTitle, keyColumn, tableColumn, breadCrumbs, menuUrl, filters };
